import { BasicWithLibelleModel } from './../basic/basicWithLibelle.model';
import { BasicModel } from '../basic/basic.model';
import { FamilleModel } from './famille.model';
import { CategorieModel } from './categorie.model';

export class SsFamilleModel extends BasicModel implements BasicWithLibelleModel  {
    // required
    idFamille: number;
    famille: FamilleModel;
    // required
    code: string;
    // max-length 80
    libelle: string;
    // liste des catégorie
    categories: CategorieModel[] = [];
}
